// @flow
export { default } from './WishTemplate';



// WEBPACK FOOTER //
// ./src/components/wish/WishTemplate/index.js